import type { Location, Category, Equipment, DisposalReason, SubCategory, SubLocation } from '@/types/settings';

export const mockLocations: Location[] = [
  {
    id: '1',
    name: 'London HQ',
    code: 'LHQ',
    notes: 'Main corporate headquarters',
    address: '123 Business Street, London, EC1A 1BB',
    mapLink: 'https://maps.google.com/?q=123+Business+Street+London+EC1A+1BB',
    locationManager: 'John Smith',
    assetCount: 17,
    createdBy: 'admin',
    createdDate: '2024-01-15T10:00:00Z',
    subLocations: [
      {
        id: 'sub-1',
        name: 'Floor 1 - Reception',
        notes: 'Ground floor reception and lobby area',
        locationManager: 'Emma Davis',
        assetCount: 3,
        parentLocationId: '1',
        createdBy: 'admin',
        createdDate: '2024-01-15T10:30:00Z',
      },
      {
        id: 'sub-2',
        name: 'Floor 2 - IT Department',
        notes: 'Second floor IT and technical services',
        locationManager: 'David Wilson',
        assetCount: 8,
        parentLocationId: '1',
        createdBy: 'admin',
        createdDate: '2024-01-15T10:35:00Z',
      },
      {
        id: 'sub-3',
        name: 'Floor 3 - Executive Offices',
        notes: 'Third floor executive and management offices',
        locationManager: 'John Smith',
        assetCount: 6,
        parentLocationId: '1',
        createdBy: 'admin',
        createdDate: '2024-01-15T10:40:00Z',
      },
    ],
  },
  {
    id: '2',
    name: 'Manchester Office',
    code: 'MAN',
    notes: 'Regional office and sales center',
    address: '456 Deansgate, Manchester, M3 2AY',
    mapLink: 'https://maps.google.com/?q=456+Deansgate+Manchester+M3+2AY',
    locationManager: 'Sarah Johnson',
    assetCount: 10,
    createdBy: 'admin',
    createdDate: '2024-01-20T14:30:00Z',
    subLocations: [
      {
        id: 'sub-4',
        name: 'Sales Floor',
        notes: 'Main sales and customer service area',
        locationManager: 'Sarah Johnson',
        assetCount: 5,
        parentLocationId: '2',
        createdBy: 'admin',
        createdDate: '2024-01-20T15:00:00Z',
      },
      {
        id: 'sub-5',
        name: 'Meeting Rooms',
        notes: 'Conference and meeting facilities',
        locationManager: 'Tom Anderson',
        assetCount: 5,
        parentLocationId: '2',
        createdBy: 'admin',
        createdDate: '2024-01-20T15:05:00Z',
      },
    ],
  },
  {
    id: '3',
    name: 'Birmingham Warehouse',
    code: 'BIR',
    notes: 'Primary warehouse and distribution center',
    address: '789 Industrial Park, Birmingham, B5 6QR',
    mapLink: 'https://maps.google.com/?q=789+Industrial+Park+Birmingham+B5+6QR',
    locationManager: 'Michael Chen',
    assetCount: 18,
    createdBy: 'admin',
    createdDate: '2024-02-01T09:15:00Z',
    subLocations: [
      {
        id: 'sub-6',
        name: 'Warehouse A - Storage',
        notes: 'Main storage area',
        locationManager: 'Michael Chen',
        assetCount: 10,
        parentLocationId: '3',
        createdBy: 'admin',
        createdDate: '2024-02-01T09:30:00Z',
      },
      {
        id: 'sub-7',
        name: 'Warehouse B - Dispatch',
        notes: 'Dispatch and loading bay',
        locationManager: 'Lisa Brown',
        assetCount: 8,
        parentLocationId: '3',
        createdBy: 'admin',
        createdDate: '2024-02-01T09:35:00Z',
      },
    ],
  },
  {
    id: '4',
    name: 'Edinburgh Branch',
    code: 'EDI',
    notes: 'Scottish regional office',
    address: '321 Princes Street, Edinburgh, EH2 4BH',
    mapLink: 'https://maps.google.com/?q=321+Princes+Street+Edinburgh+EH2+4BH',
    locationManager: 'Robert Williams',
    assetCount: 4,
    createdBy: 'admin',
    createdDate: '2024-02-10T11:45:00Z',
    subLocations: [],
  },
];

export const mockCategories: Category[] = [
  {
    id: '1',
    code: 'COMPUTER',
    description: 'Computer Equipment',
    defaultMethod: 'Straight Line',
    defaultPercentage: 25.0,
    defaultPeriodYears: 4.0,
    defaultFrequency: 'Monthly',
    userField1: 'IT Asset Tag',
    userField2: 'Software Licenses',
    userField3: 'Support Contract',
    doNotDepreciate: false,
    assetCount: 15,
    createdBy: 'admin',
    createdDate: '2024-01-10T08:00:00Z',
    subCategories: [
      {
        id: 'subcat-1',
        name: 'Laptops',
        notes: 'Portable computing devices',
        assetCount: 8,
        parentCategoryId: '1',
        createdBy: 'admin',
        createdDate: '2024-01-10T09:00:00Z',
      },
      {
        id: 'subcat-2',
        name: 'Desktops',
        notes: 'Desktop workstations',
        assetCount: 5,
        parentCategoryId: '1',
        createdBy: 'admin',
        createdDate: '2024-01-10T09:05:00Z',
      },
      {
        id: 'subcat-3',
        name: 'Peripherals',
        notes: 'Monitors, keyboards, mice, etc.',
        assetCount: 2,
        parentCategoryId: '1',
        createdBy: 'admin',
        createdDate: '2024-01-10T09:10:00Z',
      },
    ],
  },
  {
    id: '2',
    code: 'FURNITURE',
    description: 'Furniture & Fixtures',
    defaultMethod: 'Straight Line',
    defaultPercentage: 10.0,
    defaultPeriodYears: 10.0,
    defaultFrequency: 'Yearly',
    userField1: 'Room Assignment',
    userField2: 'Color/Finish',
    userField3: 'Condition',
    doNotDepreciate: false,
    assetCount: 10,
    createdBy: 'admin',
    createdDate: '2024-01-10T08:00:00Z',
    subCategories: [
      {
        id: 'subcat-4',
        name: 'Desks',
        notes: 'Office desks and workstations',
        assetCount: 4,
        parentCategoryId: '2',
        createdBy: 'admin',
        createdDate: '2024-01-10T09:15:00Z',
      },
      {
        id: 'subcat-5',
        name: 'Chairs',
        notes: 'Office chairs and seating',
        assetCount: 6,
        parentCategoryId: '2',
        createdBy: 'admin',
        createdDate: '2024-01-10T09:20:00Z',
      },
    ],
  },
  {
    id: '3',
    code: 'VEHICLES',
    description: 'Vehicles',
    defaultMethod: 'Reducing Balance',
    defaultPercentage: 20.0,
    defaultPeriodYears: 6.0,
    defaultFrequency: 'Monthly',
    userField1: 'Registration Number',
    userField2: 'MOT Expiry',
    userField3: 'Insurance Policy',
    doNotDepreciate: false,
    assetCount: 10,
    createdBy: 'admin',
    createdDate: '2024-01-10T08:00:00Z',
    subCategories: [
      {
        id: 'subcat-6',
        name: 'Cars',
        notes: 'Company cars and sedans',
        assetCount: 4,
        parentCategoryId: '3',
        createdBy: 'admin',
        createdDate: '2024-01-10T09:25:00Z',
      },
      {
        id: 'subcat-7',
        name: 'Vans',
        notes: 'Delivery and utility vans',
        assetCount: 4,
        parentCategoryId: '3',
        createdBy: 'admin',
        createdDate: '2024-01-10T09:30:00Z',
      },
      {
        id: 'subcat-8',
        name: 'Trucks',
        notes: 'Heavy goods vehicles',
        assetCount: 2,
        parentCategoryId: '3',
        createdBy: 'admin',
        createdDate: '2024-01-10T09:35:00Z',
      },
    ],
  },
  {
    id: '4',
    code: 'MACHINERY',
    description: 'Machinery',
    defaultMethod: 'Straight Line',
    defaultPercentage: 10.0,
    defaultPeriodYears: 12.0,
    defaultFrequency: 'Monthly',
    userField1: 'Machine Hours',
    userField2: 'Maintenance Log',
    userField3: 'Safety Certification',
    doNotDepreciate: false,
    assetCount: 10,
    createdBy: 'admin',
    createdDate: '2024-01-10T08:00:00Z',
    subCategories: [],
  },
  {
    id: '5',
    code: 'BUILDINGS',
    description: 'Buildings',
    defaultMethod: 'Straight Line',
    defaultPercentage: 2.0,
    defaultPeriodYears: 50.0,
    defaultFrequency: 'Yearly',
    userField1: 'Property ID',
    userField2: 'Building Type',
    userField3: 'Square Footage',
    doNotDepreciate: false,
    assetCount: 5,
    createdBy: 'admin',
    createdDate: '2024-01-10T08:00:00Z',
    subCategories: [],
  },
];

export const mockSubCategories: SubCategory[] = [
  {
    id: 'subcat-1',
    name: 'Laptops',
    notes: 'Portable computing devices',
    assetCount: 8,
    parentCategoryId: '1',
    createdBy: 'admin',
    createdDate: '2024-01-10T09:00:00Z',
  },
  {
    id: 'subcat-2',
    name: 'Desktops',
    notes: 'Desktop workstations',
    assetCount: 5,
    parentCategoryId: '1',
    createdBy: 'admin',
    createdDate: '2024-01-10T09:05:00Z',
  },
  {
    id: 'subcat-3',
    name: 'Peripherals',
    notes: 'Monitors, keyboards, mice, etc.',
    assetCount: 2,
    parentCategoryId: '1',
    createdBy: 'admin',
    createdDate: '2024-01-10T09:10:00Z',
  },
  {
    id: 'subcat-4',
    name: 'Desks',
    notes: 'Office desks and workstations',
    assetCount: 4,
    parentCategoryId: '2',
    createdBy: 'admin',
    createdDate: '2024-01-10T09:15:00Z',
  },
  {
    id: 'subcat-5',
    name: 'Chairs',
    notes: 'Office chairs and seating',
    assetCount: 6,
    parentCategoryId: '2',
    createdBy: 'admin',
    createdDate: '2024-01-10T09:20:00Z',
  },
  {
    id: 'subcat-6',
    name: 'Cars',
    notes: 'Company cars and sedans',
    assetCount: 4,
    parentCategoryId: '3',
    createdBy: 'admin',
    createdDate: '2024-01-10T09:25:00Z',
  },
  {
    id: 'subcat-7',
    name: 'Vans',
    notes: 'Delivery and utility vans',
    assetCount: 4,
    parentCategoryId: '3',
    createdBy: 'admin',
    createdDate: '2024-01-10T09:30:00Z',
  },
  {
    id: 'subcat-8',
    name: 'Trucks',
    notes: 'Heavy goods vehicles',
    assetCount: 2,
    parentCategoryId: '3',
    createdBy: 'admin',
    createdDate: '2024-01-10T09:35:00Z',
  },
];

export const mockEquipment: Equipment[] = [
  {
    id: '1',
    code: 'EQ-001',
    description: 'Toyota Forklift 3-Ton',
    acquisitionValue: 25000.0,
    acquiredDate: '2021-03-01',
    linkedAssetId: 'MACH-001',
    locationId: '3',
    userText1: 'Serial: TF3T-2021-001',
    userText2: 'Model Year: 2021',
    userText3: 'Fuel Type: Electric',
    userValue1: 12000,
    userValue2: 500,
    userDate1: '2024-03-01',
    userOption1: 'Active',
    notes: 'Regular maintenance required every 500 hours',
    supplier: {
      code: 'SUP-030',
      name: 'Industrial Equipment Ltd',
      telephone: '+44-121-555-0123',
      email: 'sales@indequip.co.uk',
      website: 'https://www.indequip.co.uk',
      hirePurchase: false,
      invoiceReference: 'INV-2021-0025',
      purchaseOrderReference: 'PO-2021-025',
      warrantyStartDate: '2021-03-01',
      warrantyFinishDate: '2024-03-01',
      warrantyCost: 2000.0,
      addresses: [
        {
          id: 'addr-1',
          type: 'Billing',
          addressLine1: '100 Industrial Way',
          city: 'Birmingham',
          state: 'West Midlands',
          postalCode: 'B5 6QR',
          country: 'UK',
          isPrimary: true,
        },
      ],
    },
    createdBy: 'admin',
    createdDate: '2021-03-01T10:00:00Z',
  },
  {
    id: '2',
    code: 'EQ-002',
    description: 'Dell Latitude 7420 Laptop',
    acquisitionValue: 1250.0,
    acquiredDate: '2022-01-15',
    linkedAssetId: 'COMP-001',
    locationId: '1',
    userText1: 'Service Tag: DL7420-001',
    userText2: 'RAM: 16GB',
    userText3: 'Storage: 512GB SSD',
    userValue1: 4,
    userDate1: '2025-01-15',
    userOption1: 'In Use',
    notes: 'Assigned to Finance Department - Sarah Johnson',
    supplier: {
      code: 'SUP-001',
      name: 'Tech Solutions UK',
      telephone: '+44-20-7946-0958',
      email: 'business@techsolutions.co.uk',
      website: 'https://www.techsolutions.co.uk',
      hirePurchase: false,
      invoiceReference: 'INV-2022-001',
      purchaseOrderReference: 'PO-2022-001',
      warrantyStartDate: '2022-01-15',
      warrantyFinishDate: '2025-01-15',
      warrantyCost: 150.0,
      addresses: [
        {
          id: 'addr-2',
          type: 'Billing',
          addressLine1: '50 Tech Street',
          city: 'London',
          state: 'Greater London',
          postalCode: 'EC1A 1BB',
          country: 'UK',
          isPrimary: true,
        },
      ],
    },
    createdBy: 'admin',
    createdDate: '2022-01-15T10:00:00Z',
  },
  {
    id: '3',
    code: 'EQ-003',
    description: 'Ford Transit Van',
    acquisitionValue: 28000.0,
    acquiredDate: '2021-06-01',
    linkedAssetId: 'VEH-001',
    locationId: '3',
    userText1: 'Registration: FT21 ABC',
    userText2: 'MOT Expiry: 2024-06-01',
    userText3: 'Insurance: POL-VEH-001',
    userValue1: 8,
    userValue2: 45000,
    userDate1: '2024-06-01',
    userOption1: 'Active',
    notes: 'Primary delivery van for Birmingham warehouse',
    supplier: {
      code: 'SUP-020',
      name: 'Ford Commercial',
      telephone: '+44-121-555-2000',
      email: 'commercial@ford.co.uk',
      website: 'https://www.ford.co.uk',
      hirePurchase: false,
      invoiceReference: 'INV-2021-045',
      purchaseOrderReference: 'PO-2021-045',
      warrantyStartDate: '2021-06-01',
      warrantyFinishDate: '2024-06-01',
      warrantyCost: 1500.0,
      addresses: [
        {
          id: 'addr-3',
          type: 'Billing',
          addressLine1: 'Ford House',
          city: 'Birmingham',
          state: 'West Midlands',
          postalCode: 'B5 7RN',
          country: 'UK',
          isPrimary: true,
        },
      ],
    },
    createdBy: 'admin',
    createdDate: '2021-06-01T10:00:00Z',
  },
  {
    id: '4',
    code: 'EQ-004',
    description: 'Herman Miller Aeron Chair',
    acquisitionValue: 950.0,
    acquiredDate: '2022-02-15',
    linkedAssetId: 'FURN-002',
    locationId: '1',
    userText1: 'Serial: HM-AERON-002',
    userText2: 'Size: B (Medium)',
    userText3: 'Color: Graphite',
    userValue1: 10,
    userDate1: '2032-02-15',
    userOption1: 'Active',
    notes: 'Ergonomic office chair for IT department',
    supplier: {
      code: 'SUP-011',
      name: 'Ergonomic Solutions',
      telephone: '+44-20-7946-1234',
      email: 'sales@ergosolutions.co.uk',
      website: 'https://www.ergosolutions.co.uk',
      hirePurchase: false,
      invoiceReference: 'INV-2022-012',
      purchaseOrderReference: 'PO-2022-012',
      warrantyStartDate: '2022-02-15',
      warrantyFinishDate: '2032-02-15',
      warrantyCost: 100.0,
      addresses: [
        {
          id: 'addr-4',
          type: 'Billing',
          addressLine1: '25 Furniture Lane',
          city: 'London',
          state: 'Greater London',
          postalCode: 'W1A 1AA',
          country: 'UK',
          isPrimary: true,
        },
      ],
    },
    createdBy: 'admin',
    createdDate: '2022-02-15T10:00:00Z',
  },
  {
    id: '5',
    code: 'EQ-005',
    description: 'CNC Milling Machine',
    acquisitionValue: 85000.0,
    acquiredDate: '2021-06-15',
    linkedAssetId: 'MACH-002',
    locationId: '3',
    userText1: 'Serial: CNC-2021-002',
    userText2: 'Model: Haas VF-2',
    userText3: 'Safety Cert: SC-2024-001',
    userValue1: 15,
    userValue2: 2500,
    userDate1: '2025-06-15',
    userOption1: 'Active',
    notes: 'Precision milling machine for production department',
    supplier: {
      code: 'SUP-031',
      name: 'Machine Tools UK',
      telephone: '+44-121-555-3000',
      email: 'sales@machinetools.co.uk',
      website: 'https://www.machinetools.co.uk',
      hirePurchase: false,
      invoiceReference: 'INV-2021-052',
      purchaseOrderReference: 'PO-2021-052',
      warrantyStartDate: '2021-06-15',
      warrantyFinishDate: '2024-06-15',
      warrantyCost: 5000.0,
      addresses: [
        {
          id: 'addr-5',
          type: 'Billing',
          addressLine1: '200 Manufacturing Road',
          city: 'Birmingham',
          state: 'West Midlands',
          postalCode: 'B6 7QR',
          country: 'UK',
          isPrimary: true,
        },
      ],
    },
    createdBy: 'admin',
    createdDate: '2021-06-15T10:00:00Z',
  },
];

export const mockDisposalReasons: DisposalReason[] = [
  {
    id: '1',
    code: 'SOLD',
    description: 'Asset sold to third party',
    createdBy: 'admin',
    createdDate: '2024-01-01T00:00:00Z',
  },
  {
    id: '2',
    code: 'OBSOLETE',
    description: 'Asset is obsolete and no longer useful',
    createdBy: 'admin',
    createdDate: '2024-01-01T00:00:00Z',
  },
  {
    id: '3',
    code: 'DAMAGED',
    description: 'Asset damaged beyond repair',
    createdBy: 'admin',
    createdDate: '2024-01-01T00:00:00Z',
  },
  {
    id: '4',
    code: 'LOST',
    description: 'Asset lost or stolen',
    createdBy: 'admin',
    createdDate: '2024-01-01T00:00:00Z',
  },
  {
    id: '5',
    code: 'DONATED',
    description: 'Asset donated to charity or organisation',
    createdBy: 'admin',
    createdDate: '2024-01-01T00:00:00Z',
  },
  {
    id: '6',
    code: 'SCRAPPED',
    description: 'Asset scrapped or recycled',
    createdBy: 'admin',
    createdDate: '2024-01-01T00:00:00Z',
  },
  {
    id: '7',
    code: 'TRADED',
    description: 'Asset traded in for new equipment',
    createdBy: 'admin',
    createdDate: '2024-01-01T00:00:00Z',
  },
];

export const mockSubLocations: SubLocation[] = [
  {
    id: 'sub-1',
    name: 'Floor 1 - Reception',
    notes: 'Ground floor reception and lobby area',
    locationManager: 'Emma Davis',
    assetCount: 3,
    parentLocationId: '1',
    createdBy: 'admin',
    createdDate: '2024-01-15T10:30:00Z',
  },
  {
    id: 'sub-2',
    name: 'Floor 2 - IT Department',
    notes: 'Second floor IT and technical services',
    locationManager: 'David Wilson',
    assetCount: 8,
    parentLocationId: '1',
    createdBy: 'admin',
    createdDate: '2024-01-15T10:35:00Z',
  },
  {
    id: 'sub-3',
    name: 'Floor 3 - Executive Offices',
    notes: 'Third floor executive and management offices',
    locationManager: 'John Smith',
    assetCount: 6,
    parentLocationId: '1',
    createdBy: 'admin',
    createdDate: '2024-01-15T10:40:00Z',
  },
  {
    id: 'sub-4',
    name: 'Sales Floor',
    notes: 'Main sales and customer service area',
    locationManager: 'Sarah Johnson',
    assetCount: 5,
    parentLocationId: '2',
    createdBy: 'admin',
    createdDate: '2024-01-20T15:00:00Z',
  },
  {
    id: 'sub-5',
    name: 'Meeting Rooms',
    notes: 'Conference and meeting facilities',
    locationManager: 'Tom Anderson',
    assetCount: 5,
    parentLocationId: '2',
    createdBy: 'admin',
    createdDate: '2024-01-20T15:05:00Z',
  },
  {
    id: 'sub-6',
    name: 'Warehouse A - Storage',
    notes: 'Main storage area',
    locationManager: 'Michael Chen',
    assetCount: 10,
    parentLocationId: '3',
    createdBy: 'admin',
    createdDate: '2024-02-01T09:30:00Z',
  },
  {
    id: 'sub-7',
    name: 'Warehouse B - Dispatch',
    notes: 'Dispatch and loading bay',
    locationManager: 'Lisa Brown',
    assetCount: 8,
    parentLocationId: '3',
    createdBy: 'admin',
    createdDate: '2024-02-01T09:35:00Z',
  },
];
